import RoutePath from 'App/RoutePath';
import { OnboardingSupportOption } from '__generated__/globalTypes';
import { OnboardingSupportOptions_onboardingSupportOptions_practicalSupport as PracticalSupportDetails } from './graphql/__generated__/OnboardingSupportOptions';
import { getSupportOptionConfig } from './supportOptions';

/**
 * Where an offering's call to action sends the member, or undefined when there
 * is nowhere meaningful to send them.
 *
 * Practical support is the exception to the fixed destinations in
 * `supportOptions`: it depends on what the member's organisation has set up. The
 * server only returns the offering when one of those exists, so having neither
 * means the response contradicted itself — better to stay put than to guess.
 */
export const getCtaDestination = (
  option: OnboardingSupportOption,
  practicalSupport?: PracticalSupportDetails | null,
): string | undefined => {
  const config = getSupportOptionConfig(option);

  if (config === undefined) {
    return undefined;
  }

  if (option === OnboardingSupportOption.PRACTICAL_SUPPORT) {
    // Only the slug the server returned: `/book/services/:service` redirects
    // back to Book for a service the member cannot book.
    if (practicalSupport?.bookableServiceSlug) {
      return `${RoutePath.BookServices}/${practicalSupport.bookableServiceSlug}`;
    }

    // `HelpServicesTabs` matches the hash against a service's `icon`.
    if (practicalSupport?.helpService) {
      return `${RoutePath.Help}#${practicalSupport.helpService.icon}`;
    }
  }

  return config.ctaDestination;
};
